// data.js
const games = [
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/loGo.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/0ed1c4fe40.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/1f7914af40.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/8dc3f2d9ad.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/9c40f44618.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/50e7c80e3a.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/75b5d81876.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/311c691438.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/128992a35d.png' },
    { name: 'providers', category: 'provider', imagePath: '/assets/bcimages/providers/providerName/b6fa55fc56.png' },
];

export default games;
